import isFunction from '../isFunction';

/**
 * Utility function trying to safely determine between elements, strings and functions so they can be rendered by react.
 * It does not provide a fail-safe mechanism, and does not actually determine renderability.
 * @param {*} child child to be rendered
 * @param {*} props props to be passed if child is a function
 * @return item able to be rendered by react
 */
export default function getRenderable(child, props) {
    if (child === undefined || child === null) {
        return null;
    }

    if (isFunction(child)) {
        return child(props);
    }

    return child;
}
